export default "__VITE_ASSET__BThuAM3x__"